module.exports = ".app {\n  color: blue;\n}\n"